export class PagedResult<T> {
  public length = 0;
  public total = 0;
  public data: T[] = [];
}
